module.exports = __webpack_public_path__ + "img/xjnx.b4fb3557.jpg";